// pages/PersonalityResult.jsx
import React from "react";
import ProgressBar from "./ProgressBar";
import PersonalityCircle from "./PersonalityCircle";
import style from "./PersonalityResult.module.css";
import Bg from "/assets/PdfNew/pgbg7.png";

const PersonalityResult = ({ big_results=[],personality_data =[]}) => {
const getColorByValue = (value = 0) => {
  if (value >= 8)
    return "linear-gradient(90deg, #B9F6D1 0%, #31C574 100%)";

  if (value >= 7)
    return "linear-gradient(90deg, #E3E3E3 0%, #FFFFFF 100%)";

  if (value >= 6)
    return "linear-gradient(90deg, #C6C5FF 0%, #5D5BFA 100%)";

  if (value >= 5)
    return "linear-gradient(90deg, #FFE2B0 0%, #FCAF2B 100%)";

  if (value >= 4)
    return "linear-gradient(90deg, #C8F7B5 0%, #2EEE00 100%)";

  return "linear-gradient(90deg, #FFB1A4 0%, #F86300 100%)";
};
const bigResultData = Object.entries(big_results).map(
    ([label, value]) => ({
      label,
      value,
      color: getColorByValue(value)
    })
  );


    const personalityData = [
        {
            topLabel: "Introvert",
            bottomLabel: "Extrovert",
            topPercent: 43,
            topColor: "#FDB515",
            bottomColor: "#FF2F92"
        },
        {
            topLabel: "Sensing (Observant)",
            bottomLabel: "Intuitive (Futuristic)",
            topPercent: 0,
            topColor: "#47E38A",
            bottomColor: "#5E5CF4"
        },
        {
            topLabel: "Thinking",
            bottomLabel: "Feeling",
            topPercent: 46,
            topColor: "#FDB515",
            bottomColor: "#FF2F92"
        },
        {
            topLabel: "Judging (Organized)",
            bottomLabel: "0% Perceiving (Spontaneous)",
            topPercent: 100,
            topColor: "#47E38A",
            bottomColor: "#47E38A"
        }
    ];

  // ---------- Personality Result (API → UI) ----------
const personalityCircleData = personality_data?.map((item, i) => {
  const topPercent = item.left_percentage;

  // 🔹 Default colors based on index (even / odd)
  let topColor = i % 2 === 0 ? "RGB(68 226 139)" : "RGB(252 175 42)";
  let bottomColor = i % 2 === 0 ? "RGB(93 90 250)" : "RGB(247 47 142)";

  if (topPercent === 0) {
    topColor = "RGB(68 226 139)";
    bottomColor = "RGB(68 226 139)";
  } else if (topPercent === 100) {
    topColor = "RGB(93 91 250)";
    bottomColor = "RGB(93 91 250)";
  }

  return {
    topLabel: `${item.left_label} ${item.left_description || ""}`.trim(),
    bottomLabel: `${item.right_label} ${item.right_description || ""}`.trim(),
    topPercent,
    topColor,
    bottomColor
  };
});

    return (
        <div className={style.PersonalityResultBg}>
            {/* Background */}
            <img src={Bg} alt="background" className={style.PersonalityResultBg} />

            <div className={style.content}>
                <h2 className={style.title}>Personality Test Result</h2>

                {/* Personality Section */}
                <div
                    style={{
                        display: "flex",
                        gap: 40,
                        justifyContent: "space-between",
                        marginBottom: 70,
                        marginTop: 30

                    }}
                >
                    {personalityCircleData.map((item, i) => (
                        <PersonalityCircle key={i} {...item} />
                    ))}
                </div>

                <h2 className={style.title}>Aptitude test results</h2>

                {/* Big Result Section */}
                {bigResultData.map((item, index) => (
                    <ProgressBar key={index} {...item} />
                ))}
            </div>
        </div>
    );
};

export default PersonalityResult;
